import { render } from "./CommentsWidget.vue.js?vue&type=template&id=74844bf9!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CommentsWidget.vue?vue&type=template&id=74844bf9"
import script from "./CommentsWidget.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CommentsWidget.vue?vue&type=script&lang=js"
export * from "./CommentsWidget.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CommentsWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-pages/story-page/CommentsWidget.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "74844bf9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('74844bf9', __exports__)) {
    api.reload('74844bf9', __exports__)
  }
  
  module.hot.accept("./CommentsWidget.vue.js?vue&type=template&id=74844bf9!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CommentsWidget.vue?vue&type=template&id=74844bf9", () => {
    api.rerender('74844bf9', render)
  })

}


export default __exports__